import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-fehlerart-list-view',
  imports: [],
  templateUrl: './fehlerart.list-view.html',
  styleUrls: ['./fehlerart.list-view.css'],
})
export class FehlerartListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
